module.exports = "/dist/montserrat-latin-400italic.svg?08e99a9b170b60eabfb9ccfe19619f45";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-400italic.svg
// module id = 73
// module chunks = 0